import { CheckCircleRounded, ErrorRounded } from "@mui/icons-material";
import { Box, ThemeProvider, Tooltip, Typography } from "@mui/material";
import { IBatchItemReturn } from "../../../model/ItemModel";
import WorkSpaceItemListFileComponentImage from "../../../pages/WorkSpaceItem/WorkSpaceItemListFileComponentImage";
import { theme } from "../BatchTheme/tooltipTheme";

interface IBatchInnerHandler {
    files: IBatchItemReturn[];
    type: "REPROVED"| "APPROVED"
}


export const BatchInnerHandler : React.FC<IBatchInnerHandler> = ({
    files,
    type
}) => {
    return (
        <>
            { type == "REPROVED" && (
                <>
                    { files?.map(({
                        extension,
                        name,
                        messageError
                    }) => (
                        <Box
                            borderBottom="1px solid #2D2D2D1A"
                            display="flex"
                            alignItems="center"
                        >
                            <Box
                                width="20px"
                                height="20px"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                marginLeft={1.5}
                            >
                                <ThemeProvider theme={theme}>
                                    <Tooltip
                                        title={messageError}
                                        arrow
                                    >
                                        <ErrorRounded 
                                            color="error"
                                        />
                                    </Tooltip>
                                </ThemeProvider>
                            </Box>
                            <Box
                                display="flex"
                                alignItems="center"
                                marginLeft={1}
                            >
                                <WorkSpaceItemListFileComponentImage 
                                    boxLayout={false}
                                    extension={extension}
                                    isFolder={false}
                                    widthIcon="20px"   
                                />
                                <Typography
                                    fontFamily="segoe ui"
                                    fontSize="14px"
                                    fontWeight={600}
                                    padding={1.5}
                                >
                                    {name}
                                </Typography>
                            </Box>
                        </Box>
                    )) }
                </>
            ) }

            { type == "APPROVED" && (
                <>                
                    { files?.map(({
                        extension,
                        name
                    }) => (
                        <Box
                            borderBottom="1px solid #2D2D2D1A"
                            display="flex"
                            alignItems="center"
                        >
                            <Box
                                width="20px"
                                height="20px"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                marginLeft={1.5}
                            >
                                <CheckCircleRounded 
                                    color="success"
                                />
                            </Box>
                            <Box
                                display="flex"
                                alignItems="center"
                                marginLeft={1}
                            >
                                <WorkSpaceItemListFileComponentImage 
                                    boxLayout={false}
                                    extension={extension}
                                    isFolder={false}
                                    widthIcon="20px"   
                                />
                                <Typography
                                    fontFamily="segoe ui"
                                    fontSize="14px"
                                    fontWeight={600}
                                    padding={1.5}
                                >
                                    {name}
                                </Typography>
                            </Box>
                        </Box>
                    )) }
                </>
            ) }
        </>
    )
}